var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":" https://ggl.h5.xeknow.com/sl/25DF3W","scrolling":"no","allowFullScreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }